export enum ISChannelOverlapRecommendationEnum {
  ADD_TO_NEGATIVES = 'ADD_TO_NEGATIVES',
  NONE = 'NO_RECOMMENDATION',
  ADDED_TO_NEGATIVES = 'ADDED_TO_NEGATIVES',
}
